module.exports = __webpack_public_path__ + "media/images/icons/social/instagram-6fa44461df9efa6902f23994bb099064.svg";